import React from "react";
import { Loader2 } from "lucide-react";
import "./DesktopBars.css";

const DesktopBottomBar = ({
  onNext,
  isNextEnabled = true,
  isLoading = false,
  nextText = "NEXT",
  nextIconSrc,

  showSkip = false,
  onSkip,
  skipText = "SKIP",
  isSkipBlue = false,

  showExit = false,
  onExit,
  exitText = "EXIT",
  isExitBlue = false,

  variant = "default", // Options: "default", "blue", "green"
  className = "",
}) => {
  return (
    <div className={`desktop-bottom-bar ${className}`}>
      {/* Left Slot: Renders EXIT (or SKIP if no Exit is present) */}
      <div className="dtb-bottom-slot dtb-slot-left">
        {showExit && (
          <button
            className="dtb-text-btn"
            style={{
              color: isExitBlue ? "#009fd9" : "rgba(255, 255, 255, 0.7)",
            }}
            onClick={onExit}
          >
            {exitText}
          </button>
        )}
        {!showExit && showSkip && (
          <button
            className="dtb-text-btn"
            style={{
              color: isSkipBlue ? "#009fd9" : "rgba(255, 255, 255, 0.7)",
            }}
            onClick={onSkip}
          >
            {skipText}
          </button>
        )}
      </div>

      {/* Center Slot: Renders SKIP ONLY if Exit is also present */}
      <div className="dtb-bottom-slot dtb-slot-center">
        {showExit && showSkip && (
          <button
            className="dtb-text-btn"
            style={{
              color: isSkipBlue ? "#009fd9" : "rgba(255, 255, 255, 0.7)",
            }}
            onClick={onSkip}
          >
            {skipText}
          </button>
        )}
      </div>

      {/* Right Slot: Renders NEXT */}
      <div className="dtb-bottom-slot dtb-slot-right">
        <div
          className={`dtb-next-wrapper ${isNextEnabled && !isLoading ? "enabled" : "disabled"}`}
          onClick={isNextEnabled && !isLoading ? onNext : undefined}
        >
          <button
            className={`dtb-next-btn dtb-variant-${variant}`}
            disabled={!isNextEnabled || isLoading}
          >
            <span className="dtb-next-text">
              {isLoading ? (
                <>
                  <Loader2
                    className="animate-spin"
                    size={20}
                    style={{ marginRight: "8px" }}
                  />
                  WAIT...
                </>
              ) : (
                nextText
              )}
            </span>
            <div className="dtb-next-icon-circle">
              {nextIconSrc && (
                <img src={nextIconSrc} alt="Next" className="dtb-next-img" />
              )}
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DesktopBottomBar;
